const AlertIcon = ({ height = 16, width = 16, style = {}, iconColor = '#F4C064', iconOpacity = 1 }) => (
  <svg
    version="1.1"
    id="Layer_1"
    viewBox="0 0 15 14"
    style={{ enableBackground: 'new 0 0 15 14', height, width, ...style }}
    xmlSpace="preserve"
    alt="alert icon"
  >
    <path className="st0" style={{ fill: iconColor, opacity: iconOpacity }} d="M13,12L7.5,2.5V12H13z" />
    <path
      className="st1"
      style={{ fill: '#17233C' }}
      d="M14.6,10.8L9.3,1.1C8.9,0.4,8.2,0,7.4,0C6.6,0,5.9,0.4,5.6,1.1l-5.3,9.7c-0.4,0.7-0.3,1.5,0,2.1
	c0.4,0.7,1.1,1,1.8,1h10.5c0.8,0,1.5-0.4,1.8-1C14.9,12.3,14.9,11.5,14.6,10.8z M13.6,12.4c-0.2,0.3-0.5,0.5-0.9,0.5H2.1
	c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.3-0.2-0.7,0-1l5.3-9.7C6.7,1.3,7,1.1,7.4,1.1c0.4,0,0.7,0.2,0.9,0.5l5.3,9.7
	C13.8,11.7,13.8,12.1,13.6,12.4z M6.9,7.1V4.4c0-0.3,0.3-0.6,0.6-0.6C7.7,3.8,8,4.1,8,4.4v2.7c0,0.3-0.3,0.6-0.6,0.6
	C7.1,7.7,6.9,7.4,6.9,7.1z M8.5,10.3c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1C8,9.2,8.5,9.7,8.5,10.3z"
    />
  </svg>
);

export default AlertIcon;
